import { render, staticRenderFns } from "./m-review-list.vue?vue&type=template&id=5c6a337a&scoped=true&"
import script from "./m-review-list.vue?vue&type=script&lang=js&"
export * from "./m-review-list.vue?vue&type=script&lang=js&"
import style0 from "./m-review-list.vue?vue&type=style&index=0&id=5c6a337a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a337a",
  null
  
)

export default component.exports